import { DatabasesDisplayPlacePageData, TablesDisplayPlacePageData, UIActions } from '@tableau/data-catalog-client-components';
import { RenderDataQualityDialogParams } from '@tableau/data-catalog-shared';

import { BrowserTitleService } from '~commonInfra/services/BrowserTitleService';
import { Telemetry } from '~commonInfra/services/Telemetry';
import { ToasterService, ToastType } from '~commonInfra/services/ToasterService';
import { TelemetryEvents, VizPortalNavigationEvent } from '~commonInfra/telemetryEvents/TelemetryEvents';
import { UrlTelemetryService } from '~commonInfra/url/UrlTelemetryService';
import { updateBreadcrumbHref } from '~src/spacesPlatform/actions/UpdateBreadcrumbHref';
import { updateBreadcrumbs } from '~src/spacesPlatform/actions/UpdateBreadcrumbsAction';
import { BreadcrumbStateInfo } from '~src/spacesPlatform/components/breadcrumbs/BreadcrumbStateInfo';

import { getAppStore } from '../../bootstrap/redux/store/AppStore';
import { renderDatabasesActionMenu, renderTablesActionMenu } from '../components/common/CatalogActionsMenu';
import { renderDataQualityDialog, renderSensitiveLabelsDialog } from './RenderDataQualityDialog';


export class DataCatalogUIActionsService implements UIActions {

  private static s_instance: DataCatalogUIActionsService | null = null;

  public static instance(): DataCatalogUIActionsService {
    if (!this.s_instance) {
      this.s_instance = new DataCatalogUIActionsService();
    }
    return this.s_instance;
  }

  public renderDatabasesActionMenu(database: DatabasesDisplayPlacePageData): JSX.Element {
    return renderDatabasesActionMenu(database);
  }

  public renderTablesActionMenu(table: TablesDisplayPlacePageData): JSX.Element {
    return renderTablesActionMenu(table);
  }

  public updateBreadcrumbs(breadcrumbs: ReadonlyArray<BreadcrumbStateInfo>) {
    getAppStore().dispatch(updateBreadcrumbs(breadcrumbs));
  }

  public updateBreadcrumbHref(href: string) {
    getAppStore().dispatch(updateBreadcrumbHref(href));
  }

  public setBrowserTitleWithPlaceNameFunction(nameFunction: () => string) {
    BrowserTitleService.setTitleWithPlaceNameFunction({ placeNameFunction: nameFunction });
  }

  public setBrowserTitleWithSpaceEntityNameAndTranslatedSubspaceName(spaceEntityName: string, translatedSubspaceName: string) {
    BrowserTitleService.setTitleWithSpaceEntityNameAndTranslatedSubspaceName({ spaceEntityName, translatedSubspaceName });
  }

  public setBrowserTitleWithPlaceEntityName(name: string) {
    BrowserTitleService.setTitleWithPlaceEntityName({ placeEntityName: name });
  }

  public popToast(type: 'success' | 'info' | 'warning' | 'error', text: string): number {
    const toastType: ToastType = getToastType(type);
    const toastId = ToasterService.instance.pop({ type: toastType, text: text });
    return toastId;
  }

  public closeToast(toastId: number) {
    ToasterService.instance.close(toastId);
  }

  public sendNavigationTelemetryEvent(newState: string, oldState: string) {
    const vizportalNavigationEvent: VizPortalNavigationEvent = {
      type: TelemetryEvents.VizPortalNavigation,
      newState,
      oldState,
      contentId: undefined,
      mixedContentEnabled: true
    };
    Telemetry.sendEvent(vizportalNavigationEvent);
  }

  public maybeSendDataQualitySubscriptionEvent(contentId: string, contentType: string) {
    UrlTelemetryService.maybeSendDataQualitySubscriptionEvent(contentId, contentType);
  }

  public renderDataQualityDialog(params: RenderDataQualityDialogParams) {
    return renderDataQualityDialog(params).then(_ => { return; });
  }

  public renderSensitiveLabelsDialog(params: RenderDataQualityDialogParams){
    return renderSensitiveLabelsDialog(params).then(_ => { return; });
  }
}

function getToastType(type: string): ToastType {
  switch (type) {
    case 'success':
      return ToastType.Success;
    case 'info':
    return ToastType.Info;
    case 'warning':
    return ToastType.Warning;
    case 'error':
    default:
    return ToastType.Error;
  }
}
